import React from "react";
import Img from "../../assets/img";
import BackBtn from "../backbtncom";
import Text from "../Text";
import { fontSizes } from "../../constants/constants";
import AuthLayoutFunction from "./index.function";
const AuthLayout = ({ isBackBnt = false, isPath, children }) => {
  const { navigate, TextWeight } = AuthLayoutFunction();
  return (
    <div
      className={`w-full px-5 py-5 sm:px-8 xl:px-32 xl:py-10 h-screen flex justify-between items-center flex-col sm:flex-row bg-center bg-no-repeat bg-cover `} // bg-dark-overlay
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.88), rgba(0, 0, 0, 0.88)), url(${Img.Bgimg})`,
      }}
    >
      {isBackBnt && <BackBtn onBack={() => navigate(isPath)} />}
      {/* Left Logo & Text */}
      <div className="w-full h-[50%] sm:w-4/12 sm:h-full flex justify-center items-center flex-col">
        <img className="w-5/12" src={Img.Logoimg} alt="companylogo" />
        <Text
          text={"Where AI Meets Construction"}
          size={fontSizes.h28}
          weight={TextWeight.Unbounded_light}
          color="text-secondary"
          isCenter={true}
          isTruncate={false}
          className={"mt-5 sm:mt-8"}
        />
      </div>
      {/* Right Form Area */}
      <div className="w-full sm:w-7/12 overflow-y-scroll hide-scrollbar bg-secondary relative h-full rounded-[40px] px-2 py-5 mt-3 sm:px-3 sm:py-5 lg:p-10">
        <div className="absolute w-40 h-40 sm:h-52 lg:w-64 lg:h-64 top-0 rounded-tr-[40px] right-0 border-primary border-r-[5px] border-t-[5px]" />

        {/* Form content goes here */}
        <div className="z-20">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
